/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentNotice } from "./PaymentNotice";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum WalletTypeEnum {
  "CARDS" = "CARDS",

  "PAYPAL" = "PAYPAL"
}

/**
 * Calculate fee request
 */

// required attributes
const CalculateFeeRequestR = t.interface({
  touchpoint: t.string,

  paymentNotices: t.readonlyArray(PaymentNotice, "array of PaymentNotice"),

  isAllCCP: t.boolean
});

// optional attributes
const CalculateFeeRequestO = t.partial({
  walletId: t.string,

  walletType: enumType<WalletTypeEnum>(WalletTypeEnum, "walletType"),

  bin: t.string,

  idPspList: t.readonlyArray(t.string, "array of string")
});

export const CalculateFeeRequest = t.intersection(
  [CalculateFeeRequestR, CalculateFeeRequestO],
  "CalculateFeeRequest"
);

export type CalculateFeeRequest = t.TypeOf<typeof CalculateFeeRequest>;
